<template>
  <v-layout justify-center>
    <v-flex xs12 sm10 md8 lg10>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12 v-if="!showTable">
            <v-card ref="search-form" v-model="valid" @keyup.enter="search">
              <v-card-text>
                <v-text-field
                  v-model="postcode"
                  label="Postcode"
                  :rules="postcodeRules"
                  mask="#### AA"
                  :readonly="loading"
                  required
                />
                <v-text-field v-model="homeNumber" label="Huisnummer" :readonly="loading" />
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="search">Zoeken</v-btn>
              </v-card-actions>
              <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
            </v-card>
          </v-flex>
          <v-flex xs12 v-if="showTable">
            <v-card ref="search-table" v-model="valid">
              <v-card-text>
                <v-data-table
                  :items="addresses"
                  :headers="headers"
                  item-key="uniqueIdAddress"
                  hide-actions
                >
                  <template v-slot:items="props">
                    <td class="text-xs-left">{{ props.item.address.street }}</td>
                    <td
                      class="text-xs-left"
                    >{{ props.item.address.homeNumber }} {{ props.item.address.addition }}</td>
                    <td class="text-xs-left">{{ props.item.address.postcode }}</td>
                    <td class="text-xs-left">{{ props.item.address.municipality }}</td>
                    <td class="text-xs-left">{{ props.item.address.city }}</td>
                    <td class="text-xs-left">
                      <v-btn icon flat color="primary" @click="load(props.item)">
                        <v-icon class="pa-2">folder</v-icon>
                      </v-btn>
                    </td>
                  </template>
                </v-data-table>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn @click="reset">Annuleer</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-flex>
    <v-snackbar bottom :timeout="timeout" v-model="notFound">Geen adressen gevonden!</v-snackbar>
    <v-snackbar bottom :timeout="timeout" v-model="requestProblem">Een onbekend server probleem</v-snackbar>
  </v-layout>
</template> 
<script>
// import { mapActions } from "vuex";
import { service } from "@/services/address";
import { mapActions } from "vuex";

export default {
  name: "AddressSearchForm",
  data: () => ({
    valid: false,
    postcode: "",
    homeNumber: "",
    timeout: 5000,
    addresses: [],
    notFound: false,
    requestProblem: false,
    showTable: false,
    loading: false,
    headers: [
      { text: "Straat", value: "address.street" },
      { text: "Huisnummer", value: "address.homeNumber" },
      { text: "Postcode", value: "address.postcode" },
      { text: "Gemeente", value: "address.municipality" },
      { text: "Plaatsnaam", value: "address.city" },
      { text: "Actie", value: "address.uniqueIdAddress" }
    ],
    postcodeRules: [v => !!v || "Postcode is verplicht"]
  }),
  methods: {
    ...mapActions(["loadAddress"]),
    load(address) {
      this.loadAddress(address);
      this.$router.push("address");
    },
    reset() {
      this.addresses = [];
      this.notFound = false;
      this.requestProblem = false;
      this.showTable = false;
    },
    search() {
      this.loading = true;
      let homeNumber = undefined;
      if (this.homeNumber) {
        homeNumber = this.homeNumber;
      }
      service
        .search(this.postcode, homeNumber)
        .then(response => {
          this.addresses = response.data;
          this.loading = false;
          this.showTable = true;
        })
        .catch(error => {
          if (error.response.status === 404) {
            this.notFound = true;
          } else {
            this.requestProblem = true;
          }
          this.loading = false;
        });
    }
  }
};
</script>